import { Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"

export function AdminHeader() {
  return (
    <header className="border-b border-border">
      <div className="container mx-auto px-4 h-14 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link href="/" className="font-mono text-lg font-bold tracking-tight">
            BROKEN SOUNDS
          </Link>
          <span className="text-xs font-mono text-muted-foreground bg-primary/20 px-2 py-0.5 rounded">
            ADMIN
          </span>
        </div>
        <nav className="flex gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link href="/admin">Dashboard</Link>
          </Button>
          <Button variant="ghost" size="sm" asChild>
            <Link href="/admin/samples">Samples</Link>
          </Button>
          <Button variant="ghost" size="sm" asChild>
            <Link href="/admin/users">Users</Link>
          </Button>
        </nav>
      </div>
    </header>
  )
}
